const Questions = [
    {
        personType: "NATURALPERSON",
        uniqueIdentifier: null,
        addresses: [
            {
                street: "Jahawar nagar",
                city: "Mumbai",
                state: "Maharashtra",
                pincode: "400043"
            }
        ],
        communications: [
            {
                communicationType: "EMAIL",
                communicationId: "harshpiparwar@gmail.com",
                isPrefferedCommunication: true
            },
            {
                communicationType: "MOBILE",
                communicationId: 8076489924,
                isPrefferedCommunication: true
            }
        ],
        identificationDocuments: [],
        isPrimaryInsuredPerson: true,
        isPolicyHolder: true,
        isPayer: true,
        isInsuredPerson: true,
        isPrimaryPolicyHolder: true,
        nominee: {
            firstName: "Sila",
            middleName: null,
            lastName: "sharma",
            dateOfbirth: "1995-08-07",
            gender: "FEMALE",
            relationship: "SISTER"
        },
        firstName: null,
        middleName: null,
        lastName: "pip",
        dateOfbirth: "1998-07-08",
        profession: "BUSINESSMAN",
        gender: "MALE",
        relationship: "SELF",
        maritalStatus: "L",
        physicalCharacteristics: {
            height: "180",
            weight: "80"
        },
        coverages: [
            {
                coverType: "48717",
                sumInsuredAmount: "500000"
            },
            {
                coverType: "48718",
                sumInsuredAmount: "500000"
            }
        ],
        medical: {
            medicalQuestions: [
                {
                    questionCode: "RICOV",
                    answerType: "BOOLEAN",
                    isApplicable: false,
                    detailAnswer: "FALSE"
                },
                {
                    questionCode: "RMPRE",
                    answerType: "BOOLEAN",
                    isApplicable: false,
                    detailAnswer: "FALSE",
                    subQuestions: [
                        {
                            questionCode: "RSPR1",
                            answerType: "TEXT_DESCRIPTION",
                            isApplicable: false,
                            detailAnswer: "FALSE"
                        },
                        {
                            questionCode: "RSPR2",
                            answerType: "DATE",
                            isApplicable: false,
                            detailAnswer: "FALSE"
                        },
                        {
                            questionCode: "RSPR3",
                            answerType: "TEXT_DESCRIPTION",
                            isApplicable: false,
                            detailAnswer: "FALSE"
                        },
                        {
                            questionCode: "RSPR4",
                            answerType: "BOOLEAN",
                            isApplicable: false,
                            detailAnswer: "FALSE"
                        }
                    ]
                },
                {
                  questionCode: "RPTHR",
                  answerType: "BOOLEAN",
                  isApplicable: false,
                  detailAnswer: "FALSE",
                  subQuestions: [
                      {
                          questionCode: "RSTH1",
                          answerType : "DOMAIN",
                          isApplicable: false,
                          detailAnswer: "TH1C"
                      },
                      {
                          questionCode: "RSTH2",
                          answerType: "TEXT_DESCRIPTION",
                          isApplicable: false,
                          detailAnswer: "FALSE"
                      },
                      {
                          questionCode: "RSTH3",
                          answerType: "DOMAIN",
                          isApplicable: false,
                          detailAnswer: "TH3A"
                      },
                      {
                          questionCode: "RSTH4",
                          answerType: "BOOLEAN",
                          isApplicable: false,
                          detailAnswer: "FALSE"
                      }
                  ]
              },
              {
                questionCode: "RPDBE",
                answerType: "BOOLEAN",
                isApplicable: false,
                detailAnswer: "FALSE",
                subQuestions: [
                    {
                        questionCode: "RSDB1",
                        answerType: "DOMAIN",
                        isApplicable: false,
                        detailAnswer: "DB1A",
                        subQuestions: []
                    },
                    {
                        questionCode: "RSDB2",
                        answerType: "DOMAIN",
                        isApplicable: false,
                        detailAnswer: "DB2A",
                        subQuestions: []
                    },
                    {
                        questionCode: "RSDB3",
                        answerType: "DOMAIN",
                        isApplicable: false,
                        detailAnswer: "DB3A",
                        subQuestions: []
                    },
                    {
                        questionCode: "RSDB4",
                        answerType: "DOMAIN",
                        isApplicable: false,
                        detailAnswer: "DB4A",
                        subQuestions: []
                    },
                    {
                        questionCode: "RSDB5",
                        answerType: "TEXT_DESCRIPTION",
                        isApplicable: false,
                        detailAnswer: "FALSE",
                        subQuestions: []
                    },
                    {
                        questionCode: "RSDB6",
                        answerType: "BOOLEAN",
                        isApplicable: false,
                        detailAnswer: "FALSE",
                        subQuestions: []
                    },
                    {
                        questionCode: "RSDB7",
                        answerType: "BOOLEAN",
                        isApplicable: false,
                        detailAnswer: "FALSE",
                        subQuestions: []
                    },
                    {
                        questionCode: "RSDB8",
                        answerType: "BOOLEAN",
                        isApplicable: false,
                        detailAnswer: "FALSE",
                        subQuestions: []
                    },
                    {
                        questionCode: "RSDB9",
                        answerType: "DOMAIN",
                        isApplicable: false,
                        detailAnswer: "DB9A",
                        subQuestions: []
                    },
                    {
                        questionCode: "RSDB10",
                        answerType: "DOMAIN",
                        isApplicable: false,
                        detailAnswer: "DB10A",
                        subQuestions: []
                    }
                ]
            },
            {
              questionCode: "RPAST",
              answerType: "BOOLEAN",
              isApplicable: false,
              detailAnswer: "FALSE",
              subQuestions: [
                  {
                      questionCode: "RSAS1",
                      answerType: "DOMAIN",
                      isApplicable: false,
                      detailAnswer: "AS1A",
                      subQuestions: []
                  },
                  {
                      questionCode: "RSAS2",
                      answerType: "DOMAIN",
                      isApplicable: false,
                      detailAnswer: "AS2B",
                      subQuestions: []
                  },
                  {
                      questionCode: "RSAS3",
                      answerType: "DOMAIN",
                      isApplicable: false,
                      detailAnswer: "AS3A",
                      subQuestions: []
                  },
                  {
                      questionCode: "RSAS4",
                      answerType: "BOOLEAN",
                      isApplicable: false,
                      detailAnswer: "FALSE",
                      subQuestions: []
                  },
                  {
                      questionCode: "RSAS5",
                      answerType: "BOOLEAN",
                      isApplicable: false,
                      detailAnswer: "FALSE",
                      subQuestions: []
                  },
                  {
                      questionCode: "RSAS6",
                      answerType: "BOOLEAN",
                      isApplicable: false,
                      detailAnswer: "FALSE",
                      subQuestions: []
                  },
                  {
                      questionCode: "RSAS7",
                      answerType: "BOOLEAN",
                      isApplicable: false,
                      detailAnswer: "FALSE",
                      subQuestions: []
                  }
              ]
            },
            {
            questionCode: "RPHPT",
            answerType: "BOOLEAN",
            isApplicable: false,
            detailAnswer: "FALSE",
            subQuestions: [
                {
                    questionCode: "RSHP1",
                    answerType: "DOMAIN",
                    isApplicable: false,
                    detailAnswer: "HP1A",
                    subQuestions: []
                },
                {
                    questionCode: "RSHP2",
                    answerType: "DOMAIN",
                    isApplicable: false,
                    detailAnswer: "HP2A",
                    subQuestions: []
                },
                {
                    questionCode: "RSHP3",
                    answerType: "DOMAIN",
                    isApplicable: false,
                    detailAnswer: "HP3C",
                    subQuestions: []
                },
                {
                    questionCode: "RSHP4",
                    answerType: "DOMAIN",
                    isApplicable: false,
                    detailAnswer: "HP4B",
                    subQuestions: []
                },
                // {
                //     questionCode: "RSHP5",
                //     answerType: "BOOLEAN",
                //     isApplicable: false,
                //     detailAnswer: "FALSE",
                //     subQuestions: []
                // },
                {
                    questionCode: "RSHP6",
                    answerType: "BOOLEAN",
                    isApplicable: false,
                    detailAnswer: "FALSE",
                    subQuestions: []
                },
                {
                    questionCode: "RSHP7",
                    answerType: "BOOLEAN",
                    isApplicable: false,
                    detailAnswer: "FALSE",
                    subQuestions: []
                },
                {
                    questionCode: "RSHP8",
                    answerType: "BOOLEAN",
                    isApplicable: false,
                    detailAnswer: "FALSE",
                    subQuestions: []
                }
            ]
            },
            {
            questionCode: "RPHLD",
            answerType: "BOOLEAN",
            isApplicable: false,
            detailAnswer: "FALSE",
            subQuestions: [
                {
                    questionCode: "RSLD1",
                    answerType: "BOOLEAN",
                    isApplicable: false,
                    detailAnswer: "FALSE",
                    subQuestions: []
                },
                {
                    questionCode: "RSLD2",
                    answerType: "BOOLEAN",
                    isApplicable: false,
                    detailAnswer: "FALSE",
                    subQuestions: []
                },
                {
                    questionCode: "RSLD3",
                    answerType: "DOMAIN",
                    isApplicable: false,
                    detailAnswer: "DL3B",
                    subQuestions: []
                }
            ]
            },
            {
            questionCode: "RPOGM",
            answerType: "BOOLEAN",
            isApplicable: false,
            detailAnswer: "FALSE",
            subQuestions: [
                {
                    questionCode: "RSGM1",
                    answerType: "TEXT_DESCRIPTION",
                    isApplicable: false,
                    detailAnswer: "FALSE",
                    subQuestions: []
                }
            ]
            },
            {
            questionCode: "RPDIG",
            answerType: "BOOLEAN",
            isApplicable: false,
            detailAnswer: "FALSE",
            subQuestions: [
                {
                    questionCode: "RSDG1",
                    answerType: "TEXT_DESCRIPTION",
                    isApplicable: false,
                    detailAnswer: "FALSE",
                    subQuestions: []
                }
            ]
            },
            {
            questionCode: "RPGYN",
            answerType: "BOOLEAN",
            isApplicable: false,
            detailAnswer: "FALSE",
            subQuestions: [
                {
                    questionCode: "RSGN1",
                    answerType: "TEXT_DESCRIPTION",
                    isApplicable: false,
                    detailAnswer: "FALSE",
                    subQuestions: []
                }
            ]
            },
            {
            questionCode: "RPTBC",
            answerType: "BOOLEAN",
            isApplicable: false,
            detailAnswer: "FALSE",
            subQuestions: [
                {
                    questionCode: "RSTB1",
                    answerType: "DOMAIN",
                    isApplicable: false,
                    detailAnswer: "TB1B",
                    subQuestions: []
                }
            ]
            },
            {
            questionCode: "RPALC",
            answerType: "BOOLEAN",
            isApplicable: false,
            detailAnswer: "FALSE",
            subQuestions: [
                {
                    questionCode: "RSAL1",
                    answerType: "DOMAIN",
                    isApplicable: false,
                    detailAnswer: "AL1C",
                    subQuestions: []
                }
            ]
            },
            ] 
        }    
    } 
];

export default Questions;